export default __webpack_public_path__ + "static/facts-items-a782fe8f432c203ef0e463d22a180bf9.webp";